import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";

// Public Pages
import HomePage from "@/pages/HomePage";
import YazilarPage from "@/pages/YazilarPage";
import ArticlePage from "@/pages/ArticlePage";
import KategorilerPage from "@/pages/KategorilerPage";
import CategoryPage from "@/pages/CategoryPage";
import HakkindaPage from "@/pages/HakkindaPage";
import IletisimPage from "@/pages/IletisimPage";
import BultenPage from "@/pages/BultenPage";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPostsList from "@/pages/admin/AdminPostsList";
import AdminPostEditor from "@/pages/admin/AdminPostEditor";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminTags from "@/pages/admin/AdminTags";
import AdminHomepageContent from "@/pages/admin/AdminHomepageContent";
import AdminAboutPage from "@/pages/admin/AdminAboutPage";
import AdminNewsletterPage from "@/pages/admin/AdminNewsletterPage";
import AdminFooterSettings from "@/pages/admin/AdminFooterSettings";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminMessageDetail from "@/pages/admin/AdminMessageDetail";
import AdminProfile from "@/pages/admin/AdminProfile";

function App() {
  return (
    <AuthProvider>
      <Toaster position="bottom-right" richColors />
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/yazilar" element={<YazilarPage />} />
          <Route path="/yazi/:slug" element={<ArticlePage />} />
          <Route path="/kategoriler" element={<KategorilerPage />} />
          <Route path="/kategori/:slug" element={<CategoryPage />} />
          <Route path="/hakkinda" element={<HakkindaPage />} />
          <Route path="/iletisim" element={<IletisimPage />} />
          <Route path="/bulten" element={<BultenPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="posts" element={<AdminPostsList />} />
            <Route path="posts/new" element={<AdminPostEditor />} />
            <Route path="posts/:id" element={<AdminPostEditor />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="tags" element={<AdminTags />} />
            <Route path="cms/homepage" element={<AdminHomepageContent />} />
            <Route path="cms/about" element={<AdminAboutPage />} />
            <Route path="cms/newsletter" element={<AdminNewsletterPage />} />
            <Route path="cms/footer" element={<AdminFooterSettings />} />
            <Route path="newsletter/subscribers" element={<AdminSubscribers />} />
            <Route path="messages" element={<AdminMessages />} />
            <Route path="messages/:id" element={<AdminMessageDetail />} />
            <Route path="profile" element={<AdminProfile />} />
          </Route>
          
          {/* Catch-all - redirect to home */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
